import React from 'react'
import PropTypes from 'prop-types'
import Rate from 'src/Components/Rate'
import APR from 'src/Components/APR'
import InlineBulletedList from 'src/Components/List/InlineBulletedList'
import Text from 'src/Components/Text'

const propTypes = {
  className: PropTypes.string,
  rate: PropTypes.number,
  apr: PropTypes.number
}

const defaultProps = {
  color: 'quiet',
  size: 's',
  element: InlineBulletedList,
  compact: true
}

const RateList = ({ rate, apr, ...restProps }) => (
  <Text {...restProps}>
    {rate != null && <Rate value={rate} />}
    {apr != null && <APR value={apr} />}
  </Text>
)

RateList.propTypes = propTypes
RateList.defaultProps = defaultProps

export default RateList
